import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Cross from "../../img/cross.png";
import Rupee from "../../img/rupee.png";
import { inRange, isEmpty, isNumber } from "lodash";
import BetSlipContext from "../../context/BetSlipContext";
import { useNavigate, useParams } from "react-router-dom";
import useScroll from "../../component/Scroll";
import BackLay from "./BackLay";
import { useTranslation } from "react-i18next";
import { FaArrowRight, FaMinus, FaPlus } from "react-icons/fa";
import AuthContext from "../../context/AuthContext";
import { FiPlus } from "react-icons/fi";
import BacLayNew from "./BacLayNew";
import moment from "moment";
import RenderSlip from "./RenderSlip";
const Selection = ({
  name,
  bookmaker,
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  profileData,
  marketName,
  detail,
  ms,
  position,
  typeGame,
  setShowBetDialog,
  setLimit,
  setBetSlipObject,
  user,
  scrollHeight,
  marketId,
  setRightTab,
  BetSlip,
  title,
  totalMatched,
  active,
  setActive,
}) => {
  const { t } = useTranslation();
  const parmas = useParams();
  const myRef = useRef(null);
  const { defaultStakeLimit, setLoginModal } = useContext(AuthContext);
  const [scrollId, setScrollId] = useScroll(myRef);
  const [localLimit, setLocalLimit] = useState({
    maxAmount: 10000000,
    minAmount: 1000,
    oddsLimit: 100,
  });

  const {
    showBetDialog,
    betSlipObject,
    handelPlaceBetFair,
    handelPlaceBookmaker,
    handelPlaceBookmakerWifi,
  } = useContext(BetSlipContext);
  const naviagte = useNavigate();
  const handelChange = (odds, type, team, item, index) => {
    if (!isEmpty(user)) {
      if (odds?.rt > 0) {
        if (!profileData?.profile?.isOneClickBetStake) {
          setScrollId(index);
          setShowBetDialog(true);
        }
        let object = {
          odds: odds?.rt,
          teamName: team,
          betType: type,
          playType: "wifiBookmaker",
          newMarketId: marketId,
          object: {
            ...item,
            ...odds,
            teamName: team,
            eventId: detail?.eventId,
            marketId: marketId,
            newMarketId: marketId,
          },
        };
        if (profileData?.profile?.isOneClickBetStake) {
          handelPlaceBookmakerWifi(localLimit, {
            ...object,
            bidPrice: profileData?.profile?.defaultOneClickBetStake,
          });
        }
        setLimit(localLimit);
        setBetSlipObject((prev) => ({
          ...prev,
          ...object,
        }));
      }
    } else {
      setLoginModal(true);
    }
  };

  const format = (number) => {
    var nf = new Intl.NumberFormat();
    return nf.format(number);
  };

  function isRtValid(obj, limit) {
    const { rt } = obj;

    // Allow undefined, null, "", or 0
    if (rt === undefined || rt === null || rt === "" || rt === 0) return true;

    // If limit is specified and rt is a number, check if it's within limit
    if (typeof rt === "number" && limit !== undefined) {
      return rt >= limit?.oddsLimit;
    }

    // Otherwise, not valid
    return false;
  }

  function checkArrays(arr1, arr2, limit) {
    return [...arr1, ...arr2].every((obj) => isRtValid(obj, limit));
  }
  return (
    <div class="main-analysis mb-2">
      <div
        style={{
          background: "rgb(48, 48, 48)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "5px 5px",
        }}
      >
        <div class="toptitle">Special Bookmaker</div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <span
            class="desktop-minmax"
            style={{ color: "white", fontSize: "12px" }}
          >
            Min: {format(localLimit?.minAmount || 100)} | Max:{" "}
            {format(localLimit?.maxAmount || 100000)}
          </span>

          <span
            class="f-right"
            style={{ paddingLeft: "5px", cursor: "pointer" }}
          >
            {active == undefined || active ? (
              <FaMinus
                size={12}
                color="white"
                onClick={() =>
                  setActive((prev) => {
                    return {
                      ...prev,
                      [name]: !prev[name],
                    };
                  })
                }
              />
            ) : (
              <FaPlus
                size={12}
                color="white"
                onClick={() =>
                  setActive((prev) => {
                    return {
                      ...prev,
                      [name]: !prev[name],
                    };
                  })
                }
              />
            )}
          </span>
        </div>
      </div>
      {(active == undefined || active) && (
        <div class="table-responsive analysis-running-market bookmakerbs">
          <table class="w-100 bets">
            <tbody
              style={{
                borderLeft: "white",
                borderRight: "white",
                position: "relative",
              }}
            >
              <tr class="bet-all-new">
                <td
                  style={{ borderRight: "none" }}
                  class="w-55 mob-minmax"
                ></td>
                <td style={{ borderLeft: "none" }} class="w-45 text-center">
                  <div>
                    <div class="w-50 float-left">
                      <>
                        <a
                          id="btnBack"
                          class="bid  btn-back mobile-hide bg-trans lh22"
                          side="Back"
                        ></a>
                        <a
                          id="btnBack"
                          class="bid  btn-back mobile-hide bg-trans lh22"
                          side="Back"
                        ></a>
                      </>

                      <a id="backAll" class="bid  back-all lh22 bid1">
                        <span class="f11">Back</span>
                      </a>
                    </div>
                    <div class="w-50 float-left">
                      <a id="layAll" class="ask  lay-all lh22 ask1">
                        <span class="f11">Lay</span>
                      </a>

                      <>
                        <a
                          id="btnBack"
                          class="ask btn-lay mobile-hide bg-trans lh22"
                          side="lay"
                        ></a>
                        <a
                          id="btnLay"
                          class="ask  btn-lay mobile-hide bg-trans lh22"
                          side="lay"
                        ></a>
                      </>
                    </div>
                  </div>
                </td>
              </tr>
              {runner?.map((item, index) => {
                let odds_back = backOdds
                  ?.filter(
                    (todd) =>
                      todd?.runnerName?.toLowerCase() ==
                      (item?.RunnerName?.toLowerCase() ||
                        item?.runnerName?.toLowerCase()),
                  )
                  ?.sort((a, b) => {
                    return a - b;
                  });
                const odds_lay = layOdds
                  ?.filter(
                    (todd) =>
                      todd?.runnerName?.toLowerCase() ==
                      (item?.RunnerName?.toLowerCase() ||
                        item?.runnerName?.toLowerCase()),
                  )
                  ?.sort((a, b) => {
                    return a - b;
                  });

                const odds_lay2 =
                  layOdds?.find(
                    (todd) =>
                      todd?.runnerName?.toLowerCase() ==
                      (item?.RunnerName?.toLowerCase() ||
                        item?.runnerName?.toLowerCase()),
                  ) || {};
                let odds_back2 =
                  backOdds?.find(
                    (todd) =>
                      todd?.runnerName?.toLowerCase() ==
                      (item?.RunnerName?.toLowerCase() ||
                        item?.runnerName?.toLowerCase()),
                  ) || {};
                let disabelBack =
                  "lockBackBets" in item ? item?.lockBackBets : false;
                let disabelLay =
                  "lockLayBets" in item ? item?.lockLayBets : false;
                let disableFull = checkArrays(odds_back, odds_lay, localLimit);

                return (
                  <>
                    <tr>
                      <td style={{ borderRight: "none" }} class="w-55">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            marginLeft: "5px",
                          }}
                        >
                          <span class="in-play-title">
                            {item?.RunnerName || item?.runnerName}
                          </span>
                          {Math.abs(item?.position) > 0 ||
                          Math.abs(item?.newPosition) ? (
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "11px",
                                marginLeft: "4px",
                              }}
                              className={` ${
                                item?.position > 0
                                  ? "text-green team-red-score"
                                  : "team-red-score"
                              }`}
                            >
                              {isNumber(item?.position) &&
                              Math.abs(item?.position) > 0
                                ? item?.position > 0
                                  ? Math?.abs(item?.position).toFixed(2)
                                  : `(${Math.abs(item?.position).toFixed(2)})`
                                : ""}
                              {Math.abs(item?.newPosition) >= 0 &&
                                showBetDialog &&
                                betSlipObject?.playType == typeGame &&
                                marketId ==
                                  betSlipObject?.object?.newMarketId && (
                                  <span
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginLeft: "4px",
                                      fontSize: "11px",
                                    }}
                                    className={
                                      item?.newPosition > 0
                                        ? "text-green"
                                        : "team-red-score"
                                    }
                                  >
                                    <FaArrowRight
                                      color={
                                        item?.newPosition > 0 ? "green" : "red"
                                      }
                                      style={{ marginRight: "3px" }}
                                    />
                                    {item?.newPosition > 0
                                      ? Math.abs(item?.newPosition).toFixed(2)
                                      : `(${Math.abs(item?.newPosition).toFixed(
                                          2,
                                        )})`}
                                  </span>
                                )}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </td>

                      <td
                        style={{ borderLeft: "none" }}
                        class="w-45 text-center position-relative"
                      >
                        <div class="">
                          <BacLayNew
                            component={typeGame}
                            index={index}
                            marketName={marketName}
                            item={item}
                            disabelBack={disabelBack}
                            oldBack={[]}
                            oldLay={[]}
                            name={name}
                            conditionNew={ms == 1}
                            disabelLay={
                              detail?.market == "Win" ? true : disabelLay
                            }
                            handelChange={handelChange}
                            isInPlay={
                              ["Win", "Winner"].includes(detail?.market)
                                ? true
                                : detail?.status == "in_play"
                                  ? true
                                  : false
                            }
                            odds_lay={odds_lay}
                            odds_back={odds_back}
                            limit={localLimit}
                            ms={ms}
                          />
                          {disableFull && ms == 1 && (
                            <div
                              style={{ borderRadius: "3px" }}
                              className="overlay-match"
                            >
                              {"Suspended"}
                            </div>
                          )}
                          {detail?.market !== "Win" &&
                          detail?.market !== "Winner" &&
                          detail?.status !== "in_play" &&
                          name !== "Bookmaker" ? (
                            <div
                              className="overlay-match-outer"
                              style={{ borderRadius: "3px" }}
                            >
                              {"Suspended"}
                            </div>
                          ) : (
                            ms != 1 && (
                              <div
                                className="overlay-match-outer"
                                style={{ borderRadius: "3px" }}
                              >
                                {"Suspended"}
                              </div>
                            )
                          )}
                        </div>
                      </td>
                    </tr>
                    {item?.selectionID == betSlipObject?.object?.selectionID &&
                      !isEmpty(betSlipObject?.betType) &&
                      betSlipObject?.playType == typeGame &&
                      !profileData?.profile?.isOneClickBetStake && (
                        <RenderSlip />
                      )}
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default React.memo(Selection);
